export class TfaVerifyRequestDto {
  constructor(
    public secret: string,
    public code: string,
  ) { }
}